import {Icon, IconProps} from '@chakra-ui/react';

export const RulesIcon2 = (props: IconProps) => (
  <Icon width="48px" height="48px" viewBox="0 0 48 48" fill="none" {...props}>
    <rect width="48" height="48" rx="24" fill="#FFFEE3" />
    <path
      d="M34 22V27C34 32 32 34 27 34H21C16 34 14 32 14 27V21C14 16 16 14 21 14H26"
      stroke="#877C2B"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M34 22H30C27 22 26 21 26 18V14L34 22Z"
      stroke="#877C2B"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M19 25H25" stroke="#877C2B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M19 29H23" stroke="#877C2B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <rect x="0.5" y="0.5" width="47" height="47" rx="23.5" stroke="#807E54" stroke-opacity="0.2" />
  </Icon>
);
